export default __webpack_public_path__ + "static/button_help-14401a08718f29bc7c6ef49503012eba.png";